import { useState } from 'react'

import hamburger_icon from "../assets/hamburger.png";

import logo_icon from "../assets/logo.jpeg";
import search_icon from "../assets/search.jpeg"
import user_icon from "../assets/user.jpeg"

import { Link, useNavigate } from 'react-router-dom';

const Head = () => {
    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState("");

    return (
        <div className="flex items-center justify-between px-2 md:px-4 py-3 md:py-6 gap-2 sticky top-0 bg-white z-[60]">
            {/* Left: Hamburger + Logo */}
            <div className="flex items-center flex-shrink-0">
                <label htmlFor="sidebar-toggle" className="cursor-pointer p-1">
                    <img className="h-7"
                        src={hamburger_icon} alt="Hamburger button" />
                </label>

                <Link to="/" className="ml-2 md:ml-4">
                    <img className="h-6 md:h-8"
                        src={logo_icon} alt="Logo" />
                </Link>
            </div>

            {/* Center: Search bar - always visible */}
            <div className="flex flex-1 max-w-xl mx-2 md:mx-4">
                <input value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && searchQuery.trim()) {
                            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
                        }
                    }}
                    className="w-full px-3 md:px-5 py-1.5 md:py-2 border border-gray-200 rounded-l-full focus:border-blue-400 focus:outline-none text-sm md:text-base"
                    placeholder="Search"
                />
                <button
                    className="px-3 md:px-6 py-1.5 md:py-2 border border-l-0 border-gray-200 rounded-r-full bg-gray-50 hover:bg-gray-100"
                    onClick={() => searchQuery.trim() && navigate(`/search?q=${encodeURIComponent(searchQuery)}`)}>
                    <img className="h-4 md:h-5" src={search_icon} alt="search" />
                </button>
            </div>

            {/* Right: User icon */}
            <div className="flex items-center flex-shrink-0">
                <img className="h-8 w-8 md:h-9 md:w-9 rounded-full cursor-pointer p-1.5 bg-blue-50 border border-blue-200 hover:bg-blue-100 hover:scale-110 transition-all"
                    src={user_icon} alt="User" />
            </div>
        </div>
    )
}

export default Head